import React from 'react';
import { useHistory, useParams } from 'react-router-dom';
import AdminLayout from '../../layouts/AdminLayout';
import ProphetFormModal from './ProphetFormModal';

export default function ProphetFormPage() {
  const history = useHistory();
  const { id } = useParams();

  const handleClose = () => {
    history.push('/prophets');
  };

  const handleSuccess = () => {
    history.push('/prophets');
  };

  return (
    <AdminLayout title={id ? 'Edit Prophet' : 'Add Prophet'}>
      <ProphetFormModal
        open={true}
        prophetId={id || null}
        onClose={handleClose}
        onSuccess={handleSuccess}
      />
    </AdminLayout>
  );
}
